import { EnterpriseModel } from 'app/gamma/src/types/models';
import { EnterpriseResponse } from 'app/gamma/src/types/responses';
import genericNormalizer from './generic';

export const normalizeEnterprise = genericNormalizer<
  EnterpriseResponse,
  EnterpriseModel
>(({ from }) => ({
  id: from('id'),
  name: from('name'),
  displayName: from('displayName'),
  logoHash: from('logoHash'),
  logoUrl: from('logoUrl'),
}));
